import { render } from "./AffiliatedInstitution.vue?vue&type=template&id=37ce266e&scoped=true"
import script from "./AffiliatedInstitution.vue?vue&type=script&lang=js"
export * from "./AffiliatedInstitution.vue?vue&type=script&lang=js"

import "./AffiliatedInstitution.vue?vue&type=style&index=0&id=37ce266e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ce266e"]])

export default __exports__